/**
 * EditorRouter Component
 *
 * TipTap is the only editor. This component fetches the document metadata to
 * surface load errors early, then always renders the TipTap EditorPage.
 * Legacy documents with editor_type 'lexical' or 'razo' also render in TipTap.
 */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../lib/axios';
import { toast } from 'sonner';
import EditorPage from './EditorPage';

const EditorRouter = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDocumentType();
  }, [documentId]);

  const fetchDocumentType = async () => {
    try {
      await axiosInstance.get(`/documents/${documentId}`);
    } catch (error) {
      console.error('Error fetching document:', error);
      if (error.response?.status !== 401) {
        toast.error('Error al cargar documento');
      }
      navigate('/dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center app-gradient">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-500 mx-auto mb-4"></div>
          <p className="text-slate-600 dark:text-slate-300">Cargando editor...</p>
        </div>
      </div>
    );
  }

  // TipTap is the only editor; every editor_type (including legacy 'lexical'
  // and 'razo') renders in TipTap.
  return <EditorPage />;
};

export default EditorRouter;

